import { useEffect } from "react";
import { useSelector } from "react-redux";
import { isWithinTimeRange } from "../../utils/isWithinTimeRange";

const HolidayNotice = ({ restaurant, setIsHoliday }) => {
  const { orderType } = useSelector((state) => state.cart);

  const isToday = (dateString) => {
    const givenDate = new Date(dateString);
    const today = new Date();
    return (
      givenDate.getFullYear() === today.getFullYear() &&
      givenDate.getMonth() === today.getMonth() &&
      givenDate.getDate() === today.getDate()
    );
  };

  const todayHoliday = restaurant?.holidays?.find((holiday) =>
    isToday(holiday.date)
  );

  const dineInAvailable = isWithinTimeRange(restaurant?.storeTiming);
  const deliveryAvailable = isWithinTimeRange(restaurant?.deliveryDays);
  const takeawayAvailable = isWithinTimeRange(restaurant?.pickupDays);

  useEffect(() => {
    if (typeof setIsHoliday !== "function") return;

    const holidayState = {
      isHoliday: false,
      title: "",
      storeTiming: false,
      type: "",
    };

    if (todayHoliday) {
      holidayState.isHoliday = true;
      holidayState.title = todayHoliday.title || "Holiday";
    }

    if (orderType === "dinein" && !dineInAvailable) {
      holidayState.storeTiming = true;
      holidayState.type = "dinein";
    } else if (orderType === "delivery" && !deliveryAvailable) {
      holidayState.storeTiming = true;
      holidayState.type = "delivery";
    } else if (orderType === "takeaway" && !takeawayAvailable) {
      holidayState.storeTiming = true;
      holidayState.type = "takeaway";
    }

    setIsHoliday(holidayState);
  }, [todayHoliday, orderType, restaurant]);

  return null;
};

export default HolidayNotice;
